var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showOverlay)?_c('div',{staticClass:"overlay"},[_vm._m(0)]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"overlay-content"},[_c('p',[_c('b',[_vm._v("Processing...")])])])
}]

export { render, staticRenderFns }